import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';


@Component({
  selector: 'repeat-section-wrapper',
  templateUrl: './repeat-section-wrapper.component.html',
  imports: [FormlyModule]
})
export class RepeatSectionWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
}
